@if (isOpen) {
<div class="notif-backdrop" (click)="close()" (keydown.escape)="close()" aria-hidden="true"></div>
}

<div class="notif-drawer-wrap" [class.notif-drawer-wrap--open]="isOpen" [attr.aria-modal]="isOpen ? 'true' : null"
  [attr.aria-label]="'Notifications' | translate" [attr.aria-hidden]="!isOpen ? 'true' : null">

  <div class="university-search-modal">

    <header class="university-search-modal__header">
      <div class="university-search-modal__header-text">
        <h2 class="university-search-modal__title">{{ 'Notifications' | translate }}</h2>
      </div>
      <button type="button" class="university-search-modal__close" (click)="close()"
        [attr.aria-label]="'Close' | translate">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
            fill="#94A3B8" />
        </svg>
      </button>
    </header>

    <div class="university-search-modal__body" (scroll)="onBodyScroll($event)">
      <div class="university-search-modal__stack notif-drawer__stack">

        <div class="notif-drawer__tabs">
          @for (tab of tabs; track tab.id) {
          <button type="button" class="notif-drawer__tab" [class.notif-drawer__tab--active]="activeTab === tab.id"
            (click)="setActiveTab(tab.id)">
            {{ tab.label | translate }}
          </button>
          }
        </div>

        @if (loading) {
        <p class="rif-no-data">{{ 'Loading' | translate }}</p>
        } @else if (notifyData.length) {
        <div class="notif-drawer__list">
          @for (item of notifyData; track item._id) {
          <button type="button" class="notif-drawer__item" (click)="onItemClick(item)">
            <span class="notif-drawer__icon" aria-hidden="true">
              <mat-icon>notifications</mat-icon>
            </span>
            <span class="notif-drawer__item-body">
              @if (item.title) {
              <span class="notif-drawer__item-title" [innerHTML]="item.title"
                [attr.aria-label]="stripHtml(item.title)"></span>
              }
              @if (item.content) {
              <span class="notif-drawer__item-content" [innerHTML]="item.content"
                [attr.aria-label]="stripHtml(item.content)"></span>
              }
              @if (item.createdAt) {
              <span class="notif-drawer__item-date">{{ item.createdAt | userTimezone: 'medium' }}</span>
              }
            </span>
          </button>
          }
        </div>
        @if (loadingMore) {
        <p class="rif-no-data">{{ 'Loading' | translate }}</p>
        }
        } @else {
        <mindbase-no-data-found />
        }

      </div>
    </div>

  </div>
</div>
